// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3788":"605c21a8","9638":"217adfc4"}[chunkId] + ".chunk.css";
};